import ZellePage from "components/pages/ZellePage";
import ChangeProfilePage from "components/pages/ChangeProfilePage";

/**
 * @function CaptureZelleSelectProfile
 * @return {React.Component}
 * @exported true
 * @description Capture component for "002_SelectProfile" in capture group "Zelle".
 */
export default function CaptureZelleSelectProfile(props) {
    return <ChangeProfilePage />;
}